const TEA_EVENT = {
  ml_metrics_click: 'ml_metrics_click',
};
export const EDIT_CREATIVES_EVENTS = {
  ml_ad_change_video_click: 'ml_ad_change_video_click',
  ml_ad_change_video_library_show: 'ml_ad_change_video_library_show',
  ml_ad_change_video_library_video_play_click: 'ml_ad_change_video_library_video_play_click',
  ml_ad_change_video_library_choose_video_click: 'ml_ad_change_video_library_choose_video_click',
  ml_ad_change_video_library_upload_click: 'ml_ad_change_video_library_upload_click',
  ml_ad_change_video_library_create_click: 'ml_ad_change_video_library_create_click',
  ml_ad_change_video_library_confirm_click: 'ml_ad_change_video_library_confirm_click',
  ml_ad_change_success_show: 'ml_ad_change_success_show',
  ml_ad_change_ttpost_click: 'ml_ad_change_ttpost_click',
  ml_ad_fail_to_make_change_show: 'ml_ad_fail_to_make_change_show',
  ml_ad_fail_to_make_change_retry_click: 'ml_ad_fail_to_make_change_retry_click',
  ml_ad_fail_to_make_change_cancel_click: 'ml_ad_fail_to_make_change_cancel_click',
  ml_ad_fail_to_upload_video_show: 'ml_ad_fail_to_upload_video_show',
  ml_ad_fail_to_upload_video_retry_click: 'ml_ad_fail_to_upload_video_retry_click',
  ml_ad_fail_to_upload_video_cancel_click: 'ml_ad_fail_to_upload_video_cancel_click',
  ml_ad_fail_to_create_video_show: 'ml_ad_fail_to_create_video_show',
  ml_ad_fail_to_create_video_retry_click: 'ml_ad_fail_to_create_video_retry_click',
  ml_ad_fail_to_create_video_cancel_click: 'ml_ad_fail_to_create_video_cancel_click',
  ml_ad_edit_ad_text_click: 'ml_ad_edit_ad_text_click',
  ml_ad_edit_CTA_click: 'ml_ad_edit_CTA_click',
  ml_ad_edit_url_click: 'ml_ad_edit_url_click',
  ml_ad_fail_to_upload_create_cancel_click: 'ml_ad_fail_to_upload_create_cancel_click',
  ml_ad_fail_to_upload_create_retry_click: 'ml_ad_fail_to_upload_create_retry_click',
};
export enum EDIT_CREATIVES_EVENTS_PARAM_VALUE {
  CHANGE_VIDEO = 'change video',
  CHANGE_TT_POST = 'change tt post',
  CHANGE_AD_TEXT = 'change ad text',
  CHANGE_CTA = 'change CTA',
  CHANGE_URL = 'change url',
  OWN_TT_POST = 'own tt post',
  AUTHORIZED_TT_POST = 'authorized tt post',
  UPLOAD = 'upload',
}

export const EDIT_CREATIVES_EVENTS_PARAM_NAME = {
  video_changing_method: 'video changing method',
  ad_changing_method: 'ad changing method',
  tt_post_changing_method: 'tt post changing method',
  page: 'page',
};
export default TEA_EVENT;
